import React from "react";
import { Form, Row, Col } from "react-bootstrap";
import InstagramOAuthPanel from "./InstagramOAuthPanel";
import WhatsAppEmbeddedSignupPanel from "./WhatsAppEmbeddedSignupPanel";

const ConfigTab = ({
    form,
    setForm,
    provider,
    channel,
    connectionId,
    onConnectionChanged
}) => {

    if (!provider) {
        return null;
    }

    const updateField = (fieldName, value) => {

        setForm(prev => ({
            ...prev,
            config: {
                ...prev.config,
                [fieldName]: value
            }
        }));

    };

    const visibleFields = channel === "instagram"
        ? provider.fields?.filter(field => ![
            "instagram_app_name",
            "instagram_app_id",
            "app_secret",
            "login_type",
            "instagram_business_account_id",
            "access_token",
            "verify_token"
        ].includes(field.name))
        : channel === "whatsapp" && provider.embeddedSignup
            ? provider.fields?.filter(field => ["country_code", "graph_version"].includes(field.name))
            : provider.fields;

    return (

        <>
            {channel === "instagram" && (
                <InstagramOAuthPanel
                    connectionId={connectionId}
                    config={form.config}
                    onConnectionChanged={onConnectionChanged}
                />
            )}
            {channel === "whatsapp" && provider.embeddedSignup && (
                <WhatsAppEmbeddedSignupPanel
                    connectionId={connectionId}
                    config={form.config}
                    onConnectionChanged={onConnectionChanged}
                />
            )}

            {/* Nome da conexão */}

            <Row className="mb-4">

                <Col md={12}>

                    <Form.Group>

                        <Form.Label>

                            Nome da conexão no Fluxo Clínica

                        </Form.Label>

                        <Form.Control
                            placeholder="Ex.: Recepção Clínica"
                            value={form.name}
                            onChange={(e) =>
                                setForm(prev => ({
                                    ...prev,
                                    name: e.target.value
                                }))
                            }
                        />

                        <Form.Text className="text-muted">

                            Nome interno usado para identificar esta conexão. Não precisa ser igual ao nome do app.

                        </Form.Text>

                    </Form.Group>

                </Col>

            </Row>

            {/* Campos do Provider */}

            <Row>

                {
                    visibleFields?.map((field) => (
                        <Col
                            md={field.col || 12}
                            key={field.name}
                            className="mb-4"
                        >

                            <Form.Group>

                                <Form.Label>

                                    {field.label}

                                    {

                                        field.required && (

                                            <span className="text-danger">

                                                {" "}*

                                            </span>

                                        )

                                    }

                                </Form.Label>

                                {
                                    field.type === "select" ? (
                                        <Form.Select
                                            value={
                                                form.config[field.name]
                                                ?? field.defaultValue
                                                ?? ""
                                            }
                                            onChange={(e) =>
                                                updateField(field.name, e.target.value)
                                            }
                                        >
                                            <option value="">Selecione...</option>

                                            {field.options?.map((option) => (
                                                <option
                                                    key={option.value}
                                                    value={option.value}
                                                >
                                                    {option.label}
                                                </option>
                                            ))}
                                        </Form.Select>
                                    ) : field.type === "checkbox" ? (
                                        <Form.Check
                                            type="switch"
                                            label={field.help || "Ativar"}
                                            checked={Boolean(form.config[field.name])}
                                            onChange={(e) =>
                                                updateField(field.name, e.target.checked)
                                            }
                                        />
                                    ) : field.type === "textarea" ? (
                                        <Form.Control
                                            as="textarea"
                                            rows={4}
                                            placeholder={field.placeholder || ""}
                                            value={form.config[field.name] || ""}
                                            onChange={(e) =>
                                                updateField(field.name, e.target.value)
                                            }
                                        />
                                    ) : (
                                        <Form.Control
                                            type={field.type || "text"}
                                            placeholder={field.placeholder || ""}
                                            value={form.config[field.name] || ""}
                                            onChange={(e) =>
                                                updateField(field.name, e.target.value)
                                            }
                                        />
                                    )
                                }
                                {

                                    field.help && (

                                        <Form.Text className="text-muted d-block mt-2">

                                            {field.help}

                                        </Form.Text>

                                    )

                                }

                            </Form.Group>

                        </Col>

                    ))

                }

            </Row>

        </>

    );

};

export default ConfigTab;
